import cities from "./cities.json";

const pageNumber = 1;
const pageSize = 10;
const maxPayment = 200000000;
const allScopes = {
  adminScopes: [
    "affiliate:read",
    "affiliate:write",
    "client:register",
    "direct:read",
    "direct:write",
    "pay:refund",
    "withdraw:refund",
  ],
  identityScopes: ["birthday", "email", "nationalcode", "phone", "profile", "shaba"],
  scopes: [
    "coupon:read",
    "coupon:write",
    "customer:read",
    "customer:write",
    "invoice:read",
    "invoice:write",
    "pay:read",
    "pay:write",
    "product:read",
    "product:write",
    "report:read",
    "upload:write",
  ],
} as const;

const cookieKeys = {
  fingerPrint: (prefix = "") => `${prefix}_user_hash`,
} as const;

const commonConstants = {
  allScopes,
  cities,
  cookieKeys,
  maxPayment,
  pageNumber,
  pageSize,
} as const;

export default commonConstants;
